import { AfterViewInit, ChangeDetectionStrategy, Component, DOCUMENT, ElementRef, Inject, Injector, Input, OnChanges, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { AppComponentBase } from '@shared/common/app-component-base';
import { PermissionCheckerService } from 'abp-ng2-module';
import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';
import { AppNavigationService } from './app-navigation.service';

import { NgClass, NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { LocalizePipe } from '@shared/common/pipes/localize.pipe';
import { DeviceDetectorService } from 'ngx-device-detector';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'side-bar-menu-upm',
    templateUrl: './side-bar-menu-upm.component.html',
    styleUrls: ['./side-bar-menu-upm.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet, RouterLink, NgClass, UpperCasePipe, LocalizePipe]
})
export class SideBarMenuUpmComponent extends AppComponentBase implements OnInit, AfterViewInit, OnChanges {

  @Input() actualTopMenuItem: AppMenuItem;

  public isDesktop: boolean;

  menu: AppMenu = null;

  currentRouteUrl = '';
  insideTm: any;
  outsideTm: any;

  constructor(
      injector: Injector,
      private el: ElementRef,
      private router: Router,
      public permission: PermissionCheckerService,
      private _appNavigationService: AppNavigationService,
      private deviceService: DeviceDetectorService,
      @Inject(DOCUMENT) private document: Document) {
      super(injector);
  }

  ngOnInit() {
      this.menu = this._appNavigationService.getMenu();
      this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
      this.isDesktop = this.deviceService.isDesktop();
      this.router.events
          .pipe(filter(event => event instanceof NavigationEnd))
          .subscribe(event => this.currentRouteUrl = this.router.url.split(/[?#]/)[0]);
  }

  ngAfterViewInit(): void {
    this.scrollToCurrentMenuElement();
}

  ngOnChanges(changes): void {
      console.log(changes.actualTopMenuItem.currentValue, "current");
  }

  showMenuItem(menuItem): boolean {
      return this._appNavigationService.showMenuItem(menuItem);
  }

  isMenuItemIsActive(item): boolean {
      if (item.items.length) {
          return this.isMenuRootItemIsActive(item);
      }

      if (!item.route) {
          return false;
      }

      // dashboard
      if (item.route !== '/' && this.currentRouteUrl.startsWith(item.route)) {
          return true;
      }

      return this.currentRouteUrl.replace(/\/$/, '') === item.route.replace(/\/$/, '');
  }

  isMenuRootItemIsActive(item): boolean {
      let result = false;

      for (const subItem of item.items) {
          result = this.isMenuItemIsActive(subItem);
          if (result) {
              return true;
          }
      }

      return false;
  }

  /**
 * Use for fixed left aside menu, to show menu on mouseenter event.
 * @param e Event
 */
  mouseEnter(e: Event) {
      if (!this.currentTheme.baseSettings.menu.allowAsideMinimizing) {
          return;
      }

      // check if the left aside menu is fixed
      if (this.document.body.classList.contains('kt-aside-left--fixed')) {
          if (this.outsideTm) {
              clearTimeout(this.outsideTm);
              this.outsideTm = null;
          }

          this.insideTm = setTimeout(() => {
              // if the left aside menu is minimized
              if (this.document.body.classList.contains('kt-aside-left--minimize') && KTUtil.isInResponsiveRange('desktop')) {
                  // show the left aside menu
                  this.document.body.classList.remove('kt-aside-left--minimize');
                  this.document.body.classList.add('kt-aside-left--minimize-hover');
              }
          }, 300);
      }
  }

  /**
   * Use for fixed left aside menu, to show menu on mouseenter event.
   * @param e Event
   */
  mouseLeave(e: Event) {
      if (!this.currentTheme.baseSettings.menu.allowAsideMinimizing) {
          return;
      }

      if (this.document.body.classList.contains('kt-aside-left--fixed')) {
          if (this.insideTm) {
              clearTimeout(this.insideTm);
              this.insideTm = null;
          }

          this.outsideTm = setTimeout(() => {
              // if the left aside menu is expand
              if (this.document.body.classList.contains('kt-aside-left--minimize-hover') && KTUtil.isInResponsiveRange('desktop')) {
                  // hide back the left aside menu
                  this.document.body.classList.remove('kt-aside-left--minimize-hover');
                  this.document.body.classList.add('kt-aside-left--minimize');
              }
          }, 500);
      }
  }

  scrollToCurrentMenuElement(): void {
    const path = location.pathname;
    const menuItem = document.querySelector('a[href=\'' + path + '\']');
    if (menuItem) {
        menuItem.scrollIntoView({ block: 'center' });
    }
  }

}
